<script>
	import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
	export default {
		name: "triangleEditor",
		mixins: [componentEditorMixin],
		data() {
			return {
				colorFlag: 0,
				triangleDirectionList: [
					{
						value: 'right',
						name: '向右'
					},
					{
						value: 'left',
						name: '向左'
					},
					{
						value: 'up',
						name: '向上'
					},
					{
						value: 'down',
						name: '向下'
					}
				],
				formList: [
					'triangleForm',
				],
				ruleList: [
					{

					}
				]
			}
		},
		computed: {
				specificForms() {
					return (
						<div class="specificForms">
								<el-collapse-item class="specificForm" title="三角效果选项" name="2">
									<template slot="default">
										<div class="specificForm">
											<el-form id="triangleForm" props={{model: this.newSettings}} ref="triangleForm"  label-style={this.formLabelStyle}>
												<el-form-item label="三角颜色" prop="triangleColor" label-position={this.labelPosition}>
													<editor-field {...{attrs: {
                              value: this.newSettings.color,
                              type: 'color',
                              varList: this.varList,
                              varJson: this.varJson,
                              showEditButton: true,
                              label:"三角颜色"
														}}}{...{on: {
															'input': val=>{
                                this.triangleColorChange(val)
                                this.handleConfirmBtnClick()
                              }
														}}}>
                          </editor-field>
												</el-form-item>
												<el-form-item label="三角方向" prop="triangleDirection" label-position={this.labelPosition}>
													<editor-field {...{attrs: {
														value: this.newSettings.triangleDirection,
														type: 'radio',
														radioList: this.triangleDirectionList,
														varList: this.varList,
														varJson: this.varJson,
														showEditButton: true,
                              label:"三角方向"
														}}}{...{on: {
															'input': val=>{
                                this.triangleDirectionChange(val)
                                this.handleConfirmBtnClick()
															}
														}}}>
                          </editor-field>
												</el-form-item>
												<el-form-item label="闪烁" prop="flash" label-position={this.labelPosition}>
                          <editor-field {...{attrs: {
                            value: this.newSettings.flash,
                            type: 'switch',
                            varList: this.varList,
                            varJson: this.varJson,
                          showEditButton: true,
                              label:"闪烁"
                            }}}{...{on: {
                              'input': val=> {
                                this.triangleFlash(val)
                                this.handleConfirmBtnClick()
                              }
                            }}}>
                          </editor-field>
												</el-form-item>
											</el-form>
										</div>
									</template>
								</el-collapse-item>
						</div>
					)
				},
			},
		
			methods: {
				triangleColorChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'background-color': val
          }
          this.newSettings.color = val
				},
				triangleDirectionChange(val){
          console.log(val);
          if(val === 'left' &&  (this.newSettings.triangleDirection == 'down' || this.newSettings.triangleDirection == 'up')){
						this.styleMergeObj = {
							...this.styleMergeObj,
							'clip-path': 'polygon(100% 0, 100% 100%, 0 50%)',
						}
            //长宽对调
            let tempHeight = this.newSettings.width
            let tempWidth = this.newSettings.height
            this.handleUniversalChangeSize(tempWidth, 'width')
            this.handleUniversalChangeSize(tempHeight, 'height')
					}
          if(val === 'left' &&  (this.newSettings.triangleDirection == 'left' || this.newSettings.triangleDirection == 'right')){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'clip-path': 'polygon(100% 0, 100% 100%, 0 50%)',
            }
          }
					if(val === 'right'&&  (this.newSettings.triangleDirection == 'down' || this.newSettings.triangleDirection == 'up')){
						this.styleMergeObj = {
							...this.styleMergeObj,
              'clip-path': 'polygon(0 0, 0 100%, 100% 50%)',
						}
            let tempHeight = this.newSettings.width
            let tempWidth = this.newSettings.height
            this.handleUniversalChangeSize(tempWidth, 'width')
            this.handleUniversalChangeSize(tempHeight, 'height')
					}
          if(val === 'right'&& (this.newSettings.triangleDirection == 'left' || this.newSettings.triangleDirection == 'right')){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'clip-path': 'polygon(0 0, 0 100%, 100% 50%)',
            }
          }
					if(val === 'up'&& (this.newSettings.triangleDirection == 'left' || this.newSettings.triangleDirection == 'right')){
						this.styleMergeObj = {
							...this.styleMergeObj,
              'clip-path': 'polygon(50% 0, 0 100%, 100% 100%)',
						}
            let tempHeight = this.newSettings.width
            let tempWidth = this.newSettings.height
            this.handleUniversalChangeSize(tempWidth, 'width')
            this.handleUniversalChangeSize(tempHeight, 'height')
					}
          if(val === 'up'&& (this.newSettings.triangleDirection == 'down' || this.newSettings.triangleDirection == 'up')){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'clip-path': 'polygon(50% 0, 0 100%, 100% 100%)',
            }
          }
					if(val === 'down' && (this.newSettings.triangleDirection == 'left' || this.newSettings.triangleDirection == 'right')){
						this.styleMergeObj = {
							...this.styleMergeObj,
              'clip-path': 'polygon(50% 100%, 0 0, 100% 0)',
						}
            let tempHeight = this.newSettings.width
            let tempWidth = this.newSettings.height
            this.handleUniversalChangeSize(tempWidth, 'width')
            this.handleUniversalChangeSize(tempHeight, 'height')
					}
          if(val === 'down' && (this.newSettings.triangleDirection == 'down' || this.newSettings.triangleDirection == 'up')){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'clip-path': 'polygon(50% 100%, 0 0, 100% 0)',
            }
          }

          this.newSettings.triangleDirection = val;
				},
				handleTriangleSizeChange(val){
					this.styleMergeObj = {
						...this.styleMergeObj,
						'border-width': val + 'px'
					}
					this.newSettings.triangleSize = val
				},
				//箭头闪烁
				triangleFlash(val){
					this.newSettings.flash = val
					if(val === true){
						this.styleMergeObj = {
							...this.styleMergeObj,
							'animation-play-state' : 'running',
						}
					}
					else if(val === false){
						this.styleMergeObj = {
							...this.styleMergeObj,
							'animation-play-state' : 'paused',
						}
					}
				},
				triangleState(val,attr){
					this.$set(this.newSettings, attr, val)
				},
			}
	}
</script>

<style lang="less">
	.triangleEditor {
		.singleSelect {
			height: 30px;
			line-height: 30px;
			width: 100%;
			border-radius: 5px;
			padding: 0 10px;
		}
	}
</style>
